/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
//import axios from "axios";

class TimelineWeekItem extends Component {
  _goItem = () => {
    const { setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;

    setContentSerial(contentSerial);
  };

  render() {
    const {
      title,
      img,
      restrictionCode,
      weekTime,
      weekTimeTv,
      comment,
      gubun,
      comment2,
    } = this.props.childProps;
    return (
      <Fragment>
        <ul className="time_tblItem">
          <li
            className="thumb"
            onClick={this._goItem}
            style={{ cursor: "pointer" }}
          >
            {restrictionCode === "19" ? <em> {restrictionCode} </em> : null}
            <img src={img} />
          </li>
          <li className="con">
            <p
              className="subject"
              style={{ cursor: "pointer" }}
              onClick={this._goItem}
            >
              {title}
            </p>
            {gubun === "LIVE" ? (
              <Fragment>
                <p className="live">
                  <span>시간</span> {weekTime}
                </p>
                <p className="first">
                  <span>첫방</span>
                  {comment.substr(0, 5)}
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <p className="tv">
                  <span>TV</span> {weekTimeTv}
                </p>
                <p className="tv">{comment2}</p>
              </Fragment>
            )}
          </li>
        </ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TimelineWeekItem));
